import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-431142cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = {
  key: 0,
  class: "col-lg-6 d-flex align-items-center mb-lg-0 mb-3"
}
const _hoisted_6 = { class: "text-nowrap me-3 col-3" }
const _hoisted_7 = { class: "search-container position-relative w-100" }
const _hoisted_8 = ["placeholder", "maxlength"]
const _hoisted_9 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_10 = { class: "me-3 text-nowrap col-3" }
const _hoisted_11 = { class: "search-container position-relative w-100 search-name" }
const _hoisted_12 = ["placeholder", "maxlength"]
const _hoisted_13 = { class: "d-flex justify-content-center mt-4 w-100" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "d-flex mb-3"
}
const _hoisted_18 = { class: "me-4" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  key: 1,
  class: "text-center fw-bold fs-4 my-5"
}
const _hoisted_22 = {
  key: 2,
  class: "text-center fw-bold fs-4 my-5"
}
const _hoisted_23 = {
  key: 4,
  class: "d-flex mb-5"
}
const _hoisted_24 = { class: "me-4" }
const _hoisted_25 = { class: "d-flex align-items-center" }

import Pagination from '@/components/pagination/index.vue'
import Button from '@/components/button/index.vue'
import { MAX_LENGTH_TITLE_SEARCH, MAX_LENGTH_USER_NAME_SEARCH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { computed, onMounted, ref, watch } from 'vue'
import Tabs, { Tab } from '@/components/tabs/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import { useRoute, useRouter } from 'vue-router'
import ChartCard from '@/views/user/conversations/components/ChartCard.vue'
import PostSkeleton from '@/components/skeletons/PostSkeleton.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import TotalRecords from '@/components/total-records/index.vue'
import conversationServices from '@/services/conversations.services'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('userManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('chatManagement'),
    to: '',
    active: true,
  },
]

const post_title = ref<string>('')
const user_name = ref<string>('')
const loading = ref<boolean>(false)
const dataChatrooms = ref({})
const dataChatCount = ref({})
const isSearch = ref(false)

const hasMessage = computed<boolean>(() => dataChatrooms.value?.data?.some((e) => e.unread_chat_count > 0))

const getChatrooms = async (params: any) => {
  if (!route.params?.id) return
  loading.value = true
  try {
    const response = await conversationServices.getChatrooms(route.params?.id, params)
    isSearch.value = !_.isEmpty(user_name.value) || !_.isEmpty(post_title.value)
    dataChatrooms.value = response?.data
    dataChatCount.value = response?.data?.total_unread_count
    tabs.map((item: any) => {
      if (item.alias === 'recruitment') item.unread_count = dataChatCount.value.recruitment_unread_count
      if (item.alias === 'job_offer') item.unread_count = dataChatCount.value.job_offer_unread_count
      if (item.alias === 'direct') item.unread_count = dataChatCount.value.direct_unread_count
      return item
    })
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

const tabs: Array<Tab> = [
  {
    title: translate('recruitment'),
    alias: 'recruitment',
    unread_count: false,
  },
  {
    title: translate('jobOffer'),
    alias: 'job_offer',
    unread_count: false,
  },
  {
    title: translate('userDirect'),
    alias: 'direct',
    unread_count: false,
  },
]
const search = (): void => {
  let params = {
    ...route.query,
    page: route.query?.page ?? 1,
    user_name: user_name.value,
    post_title: post_title.value,
    page_of_number: route.query?.page_of_number || 30,
    create_by_admin: true,
  }
  getChatrooms(params)
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])
onMounted(() => {
  if (Object.keys(route.query).length === 0) {
    router.replace({ path: route.path, query: { tab: 'recruitment' } })
  }
})

const ResetForm = () => {
  post_title.value = ''
  user_name.value = ''
}

watch(
  () => route.query?.tab,
  () => {
    ResetForm()
  },
  { immediate: true }
)

watch(
  () => route.query,
  () => {
    getChatrooms({
      ...route.query,
      tab: route.query?.tab || 'recruitment',
      user_name: user_name.value,
      post_title: post_title.value,
      create_by_admin: true,
      page_of_number: route.query?.page_of_number || 30,
    })
    //  hasMessage.value =  dataChatrooms.value.chatrooms.some((e) => e.unread_chat_count > 0)
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_Alumnus = _resolveComponent("Alumnus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('chatManagement')), 1),
      _createVNode(Tabs, {
        tabs: tabs,
        "default-alias": 'alumni',
        hasMessage: _unref(hasMessage),
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(TabPanel, {
            alias: 'alumni',
            keyName: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Alumnus)
            ]),
            _: 1
          }),
          _createVNode(TabPanel, {
            alias: 'employee',
            keyName: 2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Alumnus)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["hasMessage", "loading"]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(search, ["prevent"]),
        class: "bg-white-50 rounded-4 py-3 px-4 mb-5 w-100"
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(route).query?.tab !== 'direct')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('postTitleSearch')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: _unref(translate)('placeholder'),
                    maxlength: _unref(MAX_LENGTH_TITLE_SEARCH),
                    class: "form-control w-100",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((post_title).value = $event))
                  }, null, 8, _hoisted_8), [
                    [
                      _vModelText,
                      post_title.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('username')), 1),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: _unref(translate)('placeholder'),
                maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
                class: "form-control w-100",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user_name).value = $event))
              }, null, 8, _hoisted_12), [
                [
                  _vModelText,
                  user_name.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(Button, {
            title: _unref(translate)('CI10search'),
            type: 'secondary',
            size: 'small',
            htmlType: 'submit'
          }, null, 8, ["title"])
        ])
      ], 40, _hoisted_3),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createBlock(TotalRecords, {
            key: 1,
            totalRecords: dataChatrooms.value?.total_records
          }, null, 8, ["totalRecords"]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(Pagination, {
                totalPage: dataChatrooms.value.total_pages
              }, null, 8, ["totalPage"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataChatrooms.value?.data, (room) => {
              return (_openBlock(), _createBlock(ChartCard, {
                data: room,
                key: room.id,
                isAdmin: true
              }, null, 8, ["data"]))
            }), 128)),
            (dataChatrooms.value.loadingData)
              ? (_openBlock(), _createBlock(PostSkeleton, { key: 0 }))
              : _createCommentVNode("", true),
            (!loading.value && !dataChatrooms.value.data?.length && isSearch.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('SM10nochatSearch')), 1))
              : _createCommentVNode("", true),
            (!loading.value && !dataChatrooms.value.data?.length && !isSearch.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('SM10nochat')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(Pagination, {
                totalPage: dataChatrooms.value.total_pages
              }, null, 8, ["totalPage"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})